import { render, staticRenderFns } from "./MealOrderCard.vue?vue&type=template&id=60e4fe34&scoped=true"
import script from "./MealOrderCard.vue?vue&type=script&lang=js"
export * from "./MealOrderCard.vue?vue&type=script&lang=js"
import style0 from "./MealOrderCard.vue?vue&type=style&index=0&id=60e4fe34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e4fe34",
  null
  
)

export default component.exports